import { useSelector } from "react-redux";
import { selectCurrentUserData } from "../store/auth/index";

export const useUser = () => {
  const user = useSelector(selectCurrentUserData);
  return user;
};
